/* eslint-disable react/prop-types */
/* eslint-disable arrow-parens */
import { useEffect, useRef, useState, useCallback } from "react";
import * as d3 from "d3";
import { DATA_VISUALIZATION_PIE_CHART_COLOR_SCHEMA } from "../../../../../../../constants/pieChartColorPalette/PieChartColorPalette";
import { select, svg } from "d3";

import { Grid } from "@material-ui/core";

const EnrollmentCountPieChart = ({ data }) => {
	const isPieChartRendered = useRef(false);
	const svgPieArea = useRef(null);
	const legendContainer = useRef(null);

	const renderPieChart = useCallback(() => {
		if (isPieChartRendered.current === false) {
			const width = 648;
			const height = 780;
			const innerRadius = 200; // inner radius of pie, in pixels (non-zero for donut)
			const outerRadius = Math.min(width, height) / 2;
			const labelRadius = innerRadius * 0.2 + outerRadius * 0.8;

			const pieChartData = d3.pie().value((d) => d.enroll_count)(data);
			// console.log(pieChartData);
			const arc = d3.arc().innerRadius(innerRadius).outerRadius(outerRadius);

			const colors = d3.scaleOrdinal([
				DATA_VISUALIZATION_PIE_CHART_COLOR_SCHEMA.health_plan,
				DATA_VISUALIZATION_PIE_CHART_COLOR_SCHEMA.clinic_card,
				DATA_VISUALIZATION_PIE_CHART_COLOR_SCHEMA.group_short_term_disability,
				DATA_VISUALIZATION_PIE_CHART_COLOR_SCHEMA.group_short_term_visaibility_class_1,
				DATA_VISUALIZATION_PIE_CHART_COLOR_SCHEMA.group_short_term_visaibility_class_2,
				DATA_VISUALIZATION_PIE_CHART_COLOR_SCHEMA.hoo,
				DATA_VISUALIZATION_PIE_CHART_COLOR_SCHEMA.ksop,
				DATA_VISUALIZATION_PIE_CHART_COLOR_SCHEMA.gLI,
				DATA_VISUALIZATION_PIE_CHART_COLOR_SCHEMA.ccef
			]);

			//Adding Tooltip
			const tooldiv = d3
				.select(".enrollment-count-pie-chart")
				.append("div")
				.attr("class", "each-pie-tool-div")
				.style("visibility", "hidden")
				.style("padding", "5px 5px")
				.style("font-color", "#28a745")
				.style("position", "absolute");

			const svg = d3
				.select(svgPieArea.current)
				.attr("width", width)
				.attr("height", height)
				.attr("viewBox", [-width / 2, -height / 2, width, height])
				.attr("style", "max-width: 100%; height: auto; height: intrinsic;");

			svg.append("g")
				.selectAll("path")
				.data(pieChartData)
				.join("path")
				.attr("d", arc)
				.attr("fill", (d, i) => colors(i))
				.attr("stroke", "white")
				.style("stroke-width", "2px")
				.on("mouseover", (event, d) => {
					tooldiv
						.style("visibility", "visible")

						.text(`${d.data.plan_name}: ` + `${d.data.enroll_count}`);
					// .style("color", "#28a745")
					// .style("border", "1px solid #28a745")
					// .style("border-radius", "4px")
					// .style("background-color", "rgba(40,167,69,.12549019607843137)");
				})
				.on("mousemove", (event, d) => {
					tooldiv.style("top", event.pageY - 50 + "px").style("left", event.pageX - 50 + "px");
				})
				.on("mouseout", () => {
					tooldiv.style("visibility", "hidden");
				});

			//Adding Legend
			let legend = d3
				.select(legendContainer.current)
				.append("div")
				.attr("class", "chart-legend-container")
				.style("margin-top", "10px")
				.style("margin-left", "20px");
			// .style("background-color", "red");

			let keys = legend
				.selectAll(".key")
				.data(data)
				.enter()
				.append("div")
				.attr("class", "key")
				.style("display", "flex")
				.style("flex-direction", "row")
				.style("align-items", "center")
				.style("margin-right", "10px");

			keys.append("div")
				.attr("class", "symbol")
				.style("height", "6px")
				.style("width", "6px")
				.style("margin", "3px 3px")
				.style("background-color", (d, i) => colors(i));

			keys.append("div")
				.attr("class", "name")
				.text((d) => `${d.plan_name} `)
				.style("font-size", "9px")
				.style("font-weight", "bold");

			keys.exit().remove();
			isPieChartRendered.current = true;
		}
	}, [data]);

	/* useEffect to implementing pie chart */
	useEffect(() => {
		renderPieChart();
	}, [renderPieChart]);

	return (
		<>
			<Grid container>
				<Grid item xs={6} md={8} lg={8} xl={8} className="enrollment-count-bar-chart">
					<svg ref={svgPieArea}></svg>
				</Grid>

				<Grid
					item
					xs={6}
					sm={6}
					md={4}
					lg={4}
					xl={4}
					ref={legendContainer}
					// style={{ marginLeft: "8px" }}
				></Grid>
			</Grid>
		</>
	);
};

export default EnrollmentCountPieChart;
